import Box from '@mui/material/Box';
import { Container } from '@mui/material';
import abt from '../assets/images/AboutPage/1000.png'
import './../style/css/aboutUs.css'
function AboutPage() {
    return (
        <>
            <Box>
                <div className="pt-5">
                    <div className="chapter-heading">
                        <h2 className="text-center title-font text-light py-3 mt-1">About Us</h2>
                    </div>
                </div>
                <Container maxWidth="xl p-3" className='p-md-5 p-3 overallPadding' >
                    <div className='d-flex mt-5'>
                        <h4 className='mt-2  ms-2 title-font fw-bold' style={{ color: "#611f1e", fontSize: "30px !imporant" }}>Who We Are</h4>
                        <hr className='gallery-hori' style={{ width: "85%" }} />
                    </div>
                    <div className='row mt-5'>
                        <img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/images/logos/ELTA@I.svg`} width="50" height={75} alt='logo' className='position-absolute mb-3' style={{ right: "1vw" }} />
                        <div className='col-lg-7 mb-3 mt-5 p-0'>
                            <div className=' pt-5 px-4 text-justify  mt-5 pb-2 content-font' style={{ backgroundColor: '#bedfcc', textAlign: "justify", marginLeft: "1.2%" }}>
                                <p className='mb-5 mt-4'>The English Language Teachers’ Association of India (ELTAI), founded on August 7, 1969 by the
                                    late Padmashri S. Natarajan, a noted educationist with the pledge of committed support by five other
                                    teachers, can now claim to be the largest network of teachers of English in India, having grown both in
                                    numerical strength (from about 250 initially to about 4,000 now) and in popularity and stature since its
                                    modest beginnings through sustained professional development activities and initiatives.</p>
                                <p className='text-justify mb-5'>The seeds were sown more than half a century ago and now ELTAI has grown into a big banyan tree
                                    spreading its roots and branches nationwide into about sixty chapters, and still growing. It has been an
                                    Associate of IATEFL (UK) and an Affiliate of TESOL (USA) for long and has established partnerships with
                                    several professional associations worldwide.</p>
                                <p className='text-justify mb-5'>ELTAI’s professional publications include Journal of English Language Teaching (a bi-monthly
                                    print journal), which is given free to all the members of the Association, and three open access e-Journals,
                                    focusing on teaching and research in English literature, classroom practices in ELT, and the use of
                                    technology in ELT.</p>
                                <p className='text-justify mb-3'>We conduct and support conferences, seminars, and workshops at regional, national, and
                                    international levels on areas relevant to English studies today. Our consultancy services include support for
                                    teacher development activities, and discussions on current issues and needs relevant to the Indian context.</p>
                            </div>
                        </div>
                        <div className='col-lg-5 p-0 mb-5' style={{ marginLeft: "-1%" }}>
                            <img src={abt} className='w-100 h-100 mt-3' alt="Eltai" />
                        </div>
                    </div>

                </Container >
            </Box>
        </>

    );
}

export default AboutPage;
